'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["resolverOptions"];
import { OBJECT_PROPERTIES as OBJECT_PROPERTIES_CACHE_KEY } from 'reference-resolvers/constants/CacheKeys';
import { createCustomKey } from 'reference-resolvers/lib/CustomKey';
import { OBJECT_PROPERTIES } from 'reference-resolvers/constants/ReferenceObjectTypes';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { createGetProperties, getProperties } from 'reference-resolvers/api/PropertiesAPI';
export const toObjectPropertiesReferenceObjectType = objectTypeId => createCustomKey(OBJECT_PROPERTIES, objectTypeId);
export const createObjectPropertiesReferenceResolver = (objectTypeId, {
  resolverOptions,
  fetchQueryParams
} = {}) => createBatchedReferenceResolver(Object.assign({
  cacheKey: createCustomKey(OBJECT_PROPERTIES_CACHE_KEY, objectTypeId),
  createFetchByIds: opts => createGetProperties(Object.assign({}, opts))(objectTypeId, {
    queryParams: fetchQueryParams
  }),
  fetchByIds: getProperties(objectTypeId, {
    queryParams: fetchQueryParams
  })
}, resolverOptions));
export default ((objectTypeId, options) => {
  const opts = _objectWithoutPropertiesLoose(options, _excluded);
  return createObjectPropertiesReferenceResolver(objectTypeId, opts);
});